export const openLinkInNewTab = (url: string) => {
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (win) {
    win.focus();
  }
};
